import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
const ElementsContext = React.createContext(null);
export const ElementsProvider = ({ children, context, isMobile = false, }) => {
    return (_jsx(ElementsContext.Provider, Object.assign({ value: { context, isMobile } }, { children: children }), void 0));
};
export const useElementsContext = () => {
    const elementsContext = React.useContext(ElementsContext);
    if (!elementsContext) {
        // this is especially useful in TypeScript so you don't need to be checking for null all the time
        throw new Error("You have forgot to use ElementsProvider, shame on you.");
    }
    return elementsContext;
};
//# sourceMappingURL=elementsProvider.js.map